import {
    BaseEntityCommunication,
    EntityCommunicationResponse,
    ProcessedCommunicationResponse,
} from 'interfaces/entity-communication.interface';
import { BaseService } from '../BaseService';

export class CommunicationService extends BaseService {
    async fetchEntityCommunications(
        issueId: string,
        dateStart: string,
        dateEnd: string,
        limit?: number
    ): Promise<BaseEntityCommunication[]> {
        const communicationResponse = await super.get<EntityCommunicationResponse[]>(
            '/communications',
            {
                headers: {
                    issueId: issueId,
                    dateStart: dateStart,
                    dateEnd: dateEnd,
                    limit: limit,
                },
            }
        );

        const communicationsData: BaseEntityCommunication[] = communicationResponse.map((entry) => {
            return {
                id: +entry.comlog_id,
                comm: entry.comlog_id,
                date: entry.comm_date.split('T')[0], // Extract date part from datetime
                sector_id: String(entry.sector_id),
                institution_id: String(entry.institution_id),
                title: entry.dpoh_title_clean || '',
                organization: entry.client_clean ? entry.client_clean : '',
                sector: entry.sector ? entry.sector : '',
                dpoh: entry.dpoh_name_clean ? entry.dpoh_name_clean : '',
                institution: entry.institution ? entry.institution : '',
                lobby_firm: entry.firm_clean ? entry.firm_clean : 'In-House',
                consultant: entry.registrant_name_clean ? entry.registrant_name_clean : 'In-House',
                link: `https://lobbycanada.gc.ca/app/secure/ocl/lrs/do/cmmLgPblcVw?comlogId=${entry.comlog_id}`,
            };
        });

        return communicationsData;
    }

    async fetchProcessedEntityCommunications(
        body: any,
        issueId: string,
        dateStart: string,
        dateEnd: string
    ) {
        const processedCommunicationResponse = await super.post<ProcessedCommunicationResponse>(
            '/communications',
            body,
            {
                headers: {
                    issueId: issueId,
                    dateStart: dateStart,
                    dateEnd: dateEnd,
                },
            }
        );

        return processedCommunicationResponse;
    }
}
